<td *ngIf="showRowNumber" class="row-number-cell align-middle border-none">
  <div class="flex justify-center">
    <span class="text-xs text-gray-400 font-medium select-none whitespace-nowrap tabular-nums">{{ rowNumberDisplay }}</span>
  </div>
</td>
<td class="row-checkbox-cell align-middle border-none">
  <div class="flex justify-center">
    <p-tableCheckbox [value]="row" class="compact-checkbox" [class.select-all-mirror]="isAllSelected"></p-tableCheckbox>
  </div>
</td>
<!-- ng-container per column so the toggle column (a plain *ngIf, not part of
     `columns`) can be interspersed right after a specific index instead of
     only ever at the very end — mirrors editable-table.component.html's
     header loop, see the comment there for why. -->
<ng-container *ngFor="let col of columns; let i = index; let last = last">
  <td
    class="px-2 py-1 align-middle border-none"
    [class.last-column-cell]="last"
    [class.bg-red-50]="isRequiredEmpty(col)"
    [style.box-shadow]="columnBorderShadow(col)"
  >
    <!-- The toggle column's own transition has no real fetch behind it — just
         these specific fields briefly showing a skeleton instead of their real
         editor while the rest of the row (and the rest of the grid) stays fully
         interactive. See call-review.component.ts's onToggleColumnsChange. -->
    <p-skeleton *ngIf="isFieldLoading(col)" height="2.25rem" width="92%"></p-skeleton>

    <ng-container *ngIf="!isFieldLoading(col)">
      <app-input-text
        *ngIf="col.type === 'text'"
        #cellRef
        [(ngModel)]="row[col.field]"
        [isInvalid]="isRequiredEmpty(col)"
        [showClear]="false"
        [pTooltip]="getDisplayText(col)"
        [tooltipDisabled]="!cellRef.isTextTruncated()"
        tooltipPosition="top"
        tooltipStyleClass="custom-tooltip"
      ></app-input-text>

      <app-custom-datepicker
        *ngIf="col.type === 'date'"
        #cellRef
        [ngModel]="row[col.field]"
        (ngModelChange)="onCellValueChanged(col, $event)"
        [isInvalid]="isRequiredEmpty(col)"
        [showClear]="false"
        [pTooltip]="cellRef.formattedValue"
        [tooltipDisabled]="!cellRef.isTextTruncated()"
        tooltipPosition="top"
        tooltipStyleClass="custom-tooltip"
      ></app-custom-datepicker>

      <app-input-dropdown
        *ngIf="col.type === 'dropdown'"
        #cellRef
        [options]="col.options || emptyOptions"
        [optionLabel]="col.optionLabel || 'name'"
        [optionValue]="col.optionValue || 'id'"
        [ngModel]="row[col.field]"
        (ngModelChange)="onCellValueChanged(col, $event)"
        [isInvalid]="isRequiredEmpty(col)"
        [showClear]="false"
        [pTooltip]="cellRef.selectedObject?.[col.optionLabel || 'name']"
        [tooltipDisabled]="!cellRef.isTextTruncated()"
        tooltipPosition="top"
        tooltipStyleClass="custom-tooltip"
      ></app-input-dropdown>

      <app-input-dropdown-search
        *ngIf="col.type === 'dropdown-search'"
        #cellRef
        [options]="col.options || emptyOptions"
        [optionLabel]="col.optionLabel || 'name'"
        [optionValue]="col.optionValue || 'id'"
        [minSearchLength]="col.minSearchLength || 0"
        [totalAvailable]="col.totalAvailable ?? null"
        [ngModel]="row[col.field]"
        (ngModelChange)="onCellValueChanged(col, $event)"
        (filterChange)="col.onFilter && col.onFilter($event)"
        [isInvalid]="isRequiredEmpty(col)"
        [disabled]="isDisabled(col)"
        [showClear]="false"
        [pTooltip]="cellRef.selectedObject?.[col.optionLabel || 'name']"
        [tooltipDisabled]="!cellRef.isTextTruncated()"
        tooltipPosition="top"
        tooltipStyleClass="custom-tooltip"
      ></app-input-dropdown-search>
    </ng-container>
  </td>
  <td *ngIf="showToggleColumn && i === toggleColumnAfterIndex" class="toggle-column-cell border-none"></td>
</ng-container>
<!-- toggleColumnAfterIndex null, or >= the last column (collapsed, no extra
     columns to insert after) — render at the very end instead. -->
<td
  *ngIf="showToggleColumn && (toggleColumnAfterIndex === null || toggleColumnAfterIndex >= columns.length)"
  class="toggle-column-cell border-none"
></td>
